import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
// import { useTranslation } from 'react-i18next';
// import { EditTwoTone } from '@ant-design/icons';
import { message, Input, Pagination, Form, Select, Card, Row, Col } from 'antd';
import { app } from '../../config';
import getHeaders from '../../utils/authHeaders';
import ListinngCard from '../../layouts/ListingCard';
import AddAffiliateParent from './AddAffiliateParent';

const ShopPartnerListing = () => {
  const [fetchProdCategories, setFetchProductCategories] = useState([]);
  // const [search, setSearch] = useState('');
  const [searchShow, setSearchShow] = useState(false);
  const [pagesCount, setPagesCount] = useState(0);
  const [renderList, setRenderList] = useState([]);
  const [tableShow, setTableShow] = useState(true);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(false);
  const [show, setShow] = useState(false);

  const [err, setErr] = useState('');
  let navigate = useNavigate();

  const shopCatListingAPI = async (formData) => {
    setLoader(true);
    console.log('serachby', formData.searchTxt);
    let payload = {
      searchBy: formData.searchBy,
      limit: formData.limit,
      offset:formData.offset,
      searchTxt: formData.searchTxt
    }
      
    
    // const shopPartResp = await axios.get(`${app.URL}/api/v1/admin/shoppartner/view?searchBy=${formData.searchBy}&limit=${formData.limit}&offset=${formData.offset}&searchTxt=${formData.searchTxt}`, { headers: getHeaders() });
    const shopPartResp = await axios.post(`${app.URL}/api/v1/admin/shoppartner/search`, payload, { headers: getHeaders() });
   
    console.log('shopPartResp--->', shopPartResp);
    shopPartResp.data ? setFetchProductCategories(shopPartResp.data.result.data) : ' ';
    shopPartResp.data ? setPagesCount(shopPartResp.data.result.data.count) : ' ';
    shopPartResp.data ? setRenderList(shopPartResp.data.result.data.data) : ' ';
    shopPartResp.data.result && setLoader(false);
  };
  useEffect(() => {
    setLoader(true);
    const fetchShopCategories = async () => {
      
      let formData = {
        limit: pageSize,
        offset: 0,
        searchBy: 'email',
        searchTxt: '',
      };
     shopCatListingAPI(formData);
    };
    fetchShopCategories();
  }, []);
  let tableHeaders = ['Email', 'Created At', 'Status', ''];

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onChange = async (page, pageSize) => {
    console.log(page);
    console.log(pageSize);
    setPageSize(pageSize);
    setCurrentPage(page);
    if (!page) page = 1;
    let limit = pageSize;
    try {
      let reqObj;
      console.log(Object.keys(searchShow));
      if (Object.keys(searchShow).length !== 0) {
        reqObj = {
          limit: limit,
          offset: limit * (page - 1),
          searchBy: searchShow.searchBy,
          searchTxt: searchShow.searchItem,
        };
      } else {
        reqObj = {
          limit: limit,
          offset: limit * (page - 1),
          searchBy: 'email',
          searchTxt: '',
        };
      }
      console.log(reqObj);
      await shopCatListingAPI(reqObj);
    } catch (e) {
      console.log('Error');
      if (e.message) setErr(e.message);
      setTableShow(false);
    }
  };

  const onFinish = async (values) => {
    console.log('Success:', values);
    setSearchShow(values);
    try {
      let searchData = {
        limit: 10,
        offset: 0,
        searchBy: values.searchBy,
        searchTxt: values.searchTxt,
      };
      console.log(searchData);
      if (!searchData.searchTxt) message.error('Please enter search text');
      else await shopCatListingAPI(searchData);
    } catch (e) {
      console.log('Error');
      if (e.message) setErr(e.message);
      setTableShow(false);
    }
  };

  const editShopPartner = (event) => {
    console.log('event-->', event);

    localStorage.setItem('shopPartnerId', JSON.stringify(event));
    navigate('/shoppartner/update', { replace: true });
  };
  const addShopPartner = () => {
    navigate('/shoppartnermapping/create', { replace: true });
  };

  console.log(currentPage, pagesCount);

  let searchItems = [
    {
      name: 'Email',
      value: 'email',
    },
  ];

 

  const handleOnChange = async (e) => {
    if (e.target.value.length === 0) {
        let formData = {
          limit: pageSize,
          offset: 0,
          searchBy: '',
          searchTxt: '',
        };
        setSearchShow({});
        await shopCatListingAPI(formData);
    }
  };

  return (
    <>
      <ListinngCard
        heading='Affiliate Management'
        buttonName='Add Affiliate'
        onChange={handleOnChange}
        addButton={addShopPartner}
        addParentButton={() => setShow(true)}
        onSearch={onFinish}
        onSearchFailed={onFinishFailed}
        searchItems={searchItems}
        tableHeaders={tableHeaders}
        tableRows={renderList}
        editButton={editShopPartner}
        onPageChange={onChange}
        currentPage={currentPage}
        pagesCount={pagesCount}
        patientsListing={false}
        inventoryListing={false}
        storeListing={false}
        productListing={false}
        shopListing={true}
        affiliateParentBtn={true}
        // searchValue={searchData}
        loader={loader}
      />

      <AddAffiliateParent show={show} setShow={setShow} handleClose={() => setShow(false)}  />
    </>
  );
};

export default ShopPartnerListing;
